import { diContainer, serviceNames } from '../diContainer/diContainer';
import TransactionRepository from '../repositories/TransactionRepository';
import GiftWrapRepository from '../repositories/GiftWrapRepository';
import { computed } from 'mobx';
import Transaction from '../domain/entities/Transaction/Transaction';
import { IGiftMessageData } from '../api/GiftWrapApi';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import { NOTIFICATION_GROUP } from '../constants/Notifications';

export const PURCHASER_FORM_ERROR = 'PURCHASER_FORM_ERROR';
export const PROXY_FORM_ERROR = 'PROXY_FORM_ERROR';
export const BILLING_FORM_ERROR = 'BILLING_FORM_ERROR';

class SubmitGiftMessageUseCase {
  private giftWrapRepository: GiftWrapRepository;

  private transactionRepository: TransactionRepository;

  private notificationsCollection: NotificationsCollection;

  constructor() {
    this.giftWrapRepository = diContainer.get(serviceNames.giftWrapRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  @computed get transaction(): Transaction {
    return this.transactionRepository?.transaction;
  }

  public async execute(): Promise<void> {
    const isMessageChanged = this.giftWrapRepository.message !== '' && this.giftWrapRepository.message !== this.transaction.cardMessage;
    const shouldDeleteGiftMessage = this.giftWrapRepository.message === '' && this.giftWrapRepository.message !== this.transaction.cardMessage && this.transaction.cardMessage !== '';
    this.giftWrapRepository.setIsGiftWrapMessageLoading(true);

    if (this.notificationsCollection.hasNotification(NOTIFICATION_GROUP.GIFT_WRAP_MESSAGE)) {
      this.notificationsCollection.clearNotifications(NOTIFICATION_GROUP.GIFT_WRAP_MESSAGE);
    }
    if (isMessageChanged) {
      const giftMessageData: IGiftMessageData = {
        cardMessage: this.giftWrapRepository.message,
        cardMessageFrom: '',
        cardMessageTo: '',
        transId: Number(this?.transaction?.transId),
      };
      await this.giftWrapRepository.setGiftWrapMessage(giftMessageData);
      this.giftWrapRepository.setIsGiftWrapMessageLoading(false);
    } else if (shouldDeleteGiftMessage) {
      await this.giftWrapRepository.removeGiftWrapMessage();
      this.giftWrapRepository.setIsGiftWrapMessageLoading(false);
    } else {
      this.giftWrapRepository.setIsGiftWrapMessageLoading(false);
    }
  }
}

export default SubmitGiftMessageUseCase;
